import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getDefaultExposure} from 'helpers/player-helper';
import NumberHelper from 'helpers/number-helper';
import Action from 'actions';

class StackTeamExposureInputComponent extends Component {
    constructor(props) {
        super(props);
        const {value} = props;
        this.isValueBeingChanged = false;
        this.state = {value};
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(incomingValue) {
        const {team, groupNumber} = this.props;
        const value = NumberHelper.prepareInt(incomingValue, getDefaultExposure('max'))
            .limitByRange(0, getDefaultExposure('max'), getDefaultExposure('max'))
            .get();

        this.onChange(value);

        this.isValueBeingChanged = false;

        this.props.dispatch(Action.set('ExposureMaxOfTeamStacks', value, team, groupNumber));
    }

    getActualValue() {
        if (this.isValueBeingChanged) {
            return this.state.value;
        }
        let {groupNumber, team, lineupTeamsStacks} = this.props;
        return lineupTeamsStacks.exposureMax.getValue(groupNumber, team);
    }

    render() {
        const value = this.getActualValue();
        return (
            <input
                type="tel"
                className="form-control small-table-input"
                value={`${value}`}
                onChange={(e) => ::this.onChange(e.target.value)}
                onBlur={(e) => ::this.onBlur(e.target.value)}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {lineupTeamsStacks} = state;
    return {
        lineupTeamsStacks,
    };
}

let StackTeamExposureInput = connect(mapStatesToProps)(StackTeamExposureInputComponent);

export {StackTeamExposureInput};
